import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=83c04bbe&scoped=true&"
import script from "./activity.vue?vue&type=script&lang=js&"
export * from "./activity.vue?vue&type=script&lang=js&"
import style0 from "./activity.vue?vue&type=style&index=0&id=83c04bbe&lang=scss&scoped=true&"
import style1 from "./activity.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c04bbe",
  null
  
)

export default component.exports